import { render, staticRenderFns } from "./JSelectMultiUser.vue?vue&type=template&id=636132c2&scoped=true&"
import script from "./JSelectMultiUser.vue?vue&type=script&lang=js&"
export * from "./JSelectMultiUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636132c2",
  null
  
)

export default component.exports